<!--<div class="page-wrap">-->
<!--  <header></header>-->
<!--  <top-nav *ngIf="userIsAllowed"></top-nav>-->
<!--  <not-allowed *ngIf="!userIsAllowed"></not-allowed>-->
<!--</div>-->

<!--<footer class="site-footer"></footer>-->
@if (userIsAllowed) {
  <top-nav></top-nav>
}
@if (!userIsAllowed) {
  <not-allowed></not-allowed>
}
